import React from 'react';
import { User, Ruler, Calendar } from 'lucide-react';

/**
 * Компонент для ввода личных параметров (вес, рост, возраст, пол)
 */
const PersonalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Вес */}
      <div>
        <label htmlFor="weight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <User className="w-4 h-4 mr-2 text-blue-500" />
          Вес (кг)
        </label>
        <input
          type="text"
          id="weight"
          name="weight"
          value={formData.weight}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.weight ? 'input-error' : ''}`}
          placeholder="Введите вес в килограммах"
        />
        {errors.weight && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.weight}
          </p>
        )}
      </div>

      {/* Рост */}
      <div>
        <label htmlFor="height" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Ruler className="w-4 h-4 mr-2 text-blue-500" />
          Рост (см)
        </label>
        <input
          type="text"
          id="height"
          name="height"
          value={formData.height}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.height ? 'input-error' : ''}`}
          placeholder="Введите рост в сантиметрах"
        />
        {errors.height && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.height}
          </p>
        )}
      </div>

      {/* Возраст */}
      <div>
        <label htmlFor="age" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-blue-500" />
          Возраст (лет)
        </label>
        <input
          type="text"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.age ? 'input-error' : ''}`}
          placeholder="Введите возраст"
        />
        {errors.age && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.age}
          </p>
        )}
      </div>

      {/* Пол */}
      <div>
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Пол
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="inline-flex items-center p-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">Мужской</span>
          </label>
          <label className="inline-flex items-center p-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">Женский</span>
          </label>
        </div>
        {errors.gender && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.gender}
          </p>
        )}
      </div>

      {/* Беременность или лактация (только для женщин) */}
      {formData.gender === 'female' && (
        <div className="col-span-full">
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Беременность или грудное вскармливание
          </div>
          <div className="grid grid-cols-3 gap-2">
            <label className="inline-flex items-center p-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              <input
                type="radio"
                name="pregnancyLactation"
                value="none"
                checked={formData.pregnancyLactation === 'none'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">Нет</span>
            </label>
            <label className="inline-flex items-center p-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              <input
                type="radio"
                name="pregnancyLactation"
                value="pregnant"
                checked={formData.pregnancyLactation === 'pregnant'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">Беременность</span>
            </label>
            <label className="inline-flex items-center p-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              <input
                type="radio"
                name="pregnancyLactation"
                value="lactating"
                checked={formData.pregnancyLactation === 'lactating'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">Грудное вскармливание</span>
            </label>
          </div>
          {errors.pregnancyLactation && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.pregnancyLactation}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default PersonalParametersSection;